module.exports = __webpack_public_path__ + "img/icon8.31f765c3.png";